const IconEmptyPage = ({
  width,
  height,
}: {
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 56 56'
      fill='none'
    >
      <path
        d='M32.6667 51.3334H14C11.4227 51.3334 9.33337 49.2441 9.33337 46.6667V9.33341C9.33337 6.75608 11.4227 4.66675 14 4.66675H42C44.5774 4.66675 46.6667 6.75608 46.6667 9.33341V37.3334L32.6667 51.3334Z'
        fill='#E3E7EA'
      />
      <path
        d='M32.6666 51.3333V39.6666C32.6666 38.3779 33.7113 37.3333 35 37.3333H46.6666'
        fill='#B0BAC1'
      />
    </svg>
  )
}

export default IconEmptyPage
